module.exports = __webpack_public_path__ + "hair-on-fire.svg";